import { FC, HTMLAttributes, ReactNode } from "react";

interface Props extends HTMLAttributes<HTMLDivElement> {
	children?: ReactNode;
}

const Page: FC<Props> = ({ children, className, ...restProps }) => {
	return (
		<div className={`px-6 py-10 pr-10 ${className ?? ""}`} {...restProps}>
			{children}
		</div>
	);
};

export default Page;
